<div class="site-tree-toolbar">
  <li class="mat-tree-node" [ngClass]="{'active':  activeNode === node }" (click)="onClickOnNode(node)">
    @if (hasChildren) {
    <button
      mat-icon-button
      matTreeNodeToggle
      [attr.aria-label]="'toggle ' + node.id"
      type="button"
      (click)="onNodeToggle(node)">
      <mat-icon class="mat-icon-rtl-mirror"> {{ expanded ? 'expand_more' : 'chevron_right'}} </mat-icon>
    </button>
    }

    <div class="directory-tree-label">
      <app-tree-leaf-display [node]="node" [ngClass]="{  'active': activeNode === node  }"></app-tree-leaf-display>
      <div class="directory-tree-label-buttons">
        <div class="directory-tree-label-buttons" [hidden]="activeNode !== node">
          <!--  *ngIf="!node.entity.fixed || node.entity.aliasOf"-->
          @if (node.entity.operations.canDelete) {
          <button mat-icon-button color="accent" (click)="onDeleteClicked(node)" type="button">
            <mat-icon class="mat-icon-rtl-mirror"> delete </mat-icon>
          </button>
          }
          <!-- *ngIf="node.level + 1 < fieldConfig.treeOptions.depth && !node.entity.fixed" -->
          @if (node.entity.operations.canAdd) {
          <button mat-icon-button color="accent" (click)="onNewClicked(node)" type="button">
            <mat-icon class="mat-icon-rtl-mirror"> create_new_folder </mat-icon>
          </button>
          } @if (node.entity.operations.canEdit) {
          <button mat-icon-button color="accent" (click)="onEditClicked(node)" type="button">
            <mat-icon class="mat-icon-rtl-mirror"> edit </mat-icon>
          </button>
          }
          <!-- [hidden]="node.entity.reorderBlocked"-->
          @if (node.entity.operations.canMove) {
          <button mat-icon-button color="accent" cdkDragHandle type="button">
            <mat-icon class="mat-icon-rtl-mirror" style="line-height: 4px">
              <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            </mat-icon>
          </button>
          }
        </div>
      </div>
    </div>
  </li>
</div>
